export default {
	tab_manager_close_all_tabs_context_menu_label: 'Close all tabs',
	tab_manager_close_other_tabs_context_menu_label: 'Close other tabs',
	tab_manager_close_tab_context_menu_label: 'Close tab',
	tab_manager_unsaved_changes_dialog_abort_label: 'Cancel',
	tab_manager_unsaved_changes_dialog_confirm_cancel_label: 'Discard',
	tab_manager_unsaved_changes_dialog_confirm_message: 'You still have unsaved changes. Do you want to save them?',
	tab_manager_unsaved_changes_dialog_confirm_ok_label: 'Save',
	tab_manager_unsaved_changes_dialog_confirm_title: 'Unsaved changes',
	tab_manager_unsaved_changes_dialog_save_all_label: 'Save all',
	tab_manager_unsaved_changes_dialog_send_label: 'Send',
	tab_manager_unsaved_changes_dialog_unsent_title: 'Unsent message',
};
